import { useSyncExternalStore } from 'react';
import {
  getActiveOrganizationId,
  setActiveOrganizationId,
  subscribeActiveOrganization,
} from '../activeOrganization';

/**
 * Re-renders the caller when the tab's active organization changes. The value is the module
 * store the request interceptor reads, so components and API clients agree without context
 * plumbing or rebuilding clients; initialization seeds it via `setActiveOrganizationId`.
 */
export function useActiveOrganization(): {
  activeOrganizationId: string | null;
  setActiveOrganization: (organizationId: string | null) => void;
} {
  const activeOrganizationId = useSyncExternalStore(
    subscribeActiveOrganization,
    getActiveOrganizationId,
    getActiveOrganizationId,
  );
  return { activeOrganizationId, setActiveOrganization: setActiveOrganizationId };
}
